import { RADIOS_INITIAL_VALUES } from '../../lib/buildInitialState';

export const OBSERVATIONS_INITIAL_VALUES = {
	na: false,
	m: false,
	n: false
};

export const VIOLATION_INITIAL_VALUES = {
	description: '',
	majorModerateMinor: ''
};

export const INITIAL_FORM_STATE = {
	info: {
		completed_by: {
			title: 'Completed By',
			value: ''
		},
		date: {
			title: 'Date',
			value: ''
		},
		project_location: {
			title: 'Project / Location',
			value: ''
		},
		project_number: {
			title: 'Project Number',
			value: ''
		},
		project_manager: {
			title: 'Project Manager',
			value: ''
		},
		supervisor: {
			title: 'Supervisor',
			value: ''
		},
		project_description_activity: {
			title: 'Project Description / Activity',
			value: ''
		}
	},
	observations: {
		safety: {
			title: 'Safety',
			fields: {
				ppe: {
					title: 'PPE',
					...OBSERVATIONS_INITIAL_VALUES
				},
				fall_protection: {
					title: 'Fall Protection',
					...OBSERVATIONS_INITIAL_VALUES
				},
				ladders_scaffolds: {
					title: 'Ladders / Scaffolds',
					...OBSERVATIONS_INITIAL_VALUES
				},
				confined_space: {
					title: 'Confined Space',
					...OBSERVATIONS_INITIAL_VALUES
				},
				hand_and_power_tools: {
					title: 'Hand & Power Tools',
					...OBSERVATIONS_INITIAL_VALUES
				},
				hot_work: {
					title: 'Hot Work',
					...OBSERVATIONS_INITIAL_VALUES
				},
				lockout_tagout: {
					title: 'Lockout / Tagout',
					...OBSERVATIONS_INITIAL_VALUES
				},
				lifting_material_handling: {
					title: 'Lifting / Material Handling',
					...OBSERVATIONS_INITIAL_VALUES
				},
				body_position_line_of_fire: {
					title: 'Body Position / Line of Fire',
					...OBSERVATIONS_INITIAL_VALUES
				}
			}
		},
		supervisor_performance: {
			title: 'Supervisor Performance',
			fields: {
				pre_job_briefing_aha_review: {
					title: 'Pre-job Briefing / AHA Review',
					...OBSERVATIONS_INITIAL_VALUES
				},
				job_planning_work_coordination: {
					title: 'Job Planning / Work Coordination',
					...OBSERVATIONS_INITIAL_VALUES
				},
				establishes_reinforces_safety_expectations: {
					title: 'Establishes / Reinforces Safety Expectations',
					...OBSERVATIONS_INITIAL_VALUES
				},
				monitors_and_mentors_employees: {
					title: 'Monitors and Mentors Employees',
					...OBSERVATIONS_INITIAL_VALUES
				},
				identifies_hazards_and_takes_action_to_correct: {
					title: 'Identifies Hazards and Takes Action to Correct',
					...OBSERVATIONS_INITIAL_VALUES
				},
				manages_changes_and_revises_aha: {
					title: 'Manages Changes and Revises AHA',
					...OBSERVATIONS_INITIAL_VALUES
				},
				encourages_participation_by_entire_crew: {
					title: 'Encourages Participation by Entire Crew',
					...OBSERVATIONS_INITIAL_VALUES
				},
				tracks_and_reports_incidents_near_misses: {
					title: 'Tracks and Reports Incidents / Near Misses',
					...OBSERVATIONS_INITIAL_VALUES
				},
				completes_required_safety_documentation: {
					title: 'Completes Required Safety Documentation',
					...OBSERVATIONS_INITIAL_VALUES
				}
			}
		},
		operations: {
			title: 'Operations',
			fields: {
				diving: {
					title: 'Diving',
					...OBSERVATIONS_INITIAL_VALUES
				},
				boat_operations: {
					title: 'Boat Operations',
					...OBSERVATIONS_INITIAL_VALUES
				},
				motor_vehicles_and_trailers: {
					title: 'Motor Vehicles and Trailers',
					...OBSERVATIONS_INITIAL_VALUES
				},
				cranes_lifts_rigging: {
					title: 'Cranes / Lifts / Rigging',
					...OBSERVATIONS_INITIAL_VALUES
				},
				loading_unloading: {
					title: 'Loading / Unloading',
					...OBSERVATIONS_INITIAL_VALUES
				},
				concrete_and_grout: {
					title: 'Concrete and Grout',
					...OBSERVATIONS_INITIAL_VALUES
				},
				burning_and_cutting: {
					title: 'Burning and Cutting',
					...OBSERVATIONS_INITIAL_VALUES
				},
				other: {
					title: 'Other (specify)',
					...OBSERVATIONS_INITIAL_VALUES
				}
			}
		},
		human_environmental_factors: {
			title: 'Human / Environmental Factors',
			fields: {
				housekeeping: {
					title: 'Housekeeping',
					...OBSERVATIONS_INITIAL_VALUES
				},
				fuel_storage_and_containment_spill_prevention: {
					title: 'Fuel Storage & Containment / Spill Prevention',
					...OBSERVATIONS_INITIAL_VALUES
				},
				excessive_time_pressure_multiple_tasks: {
					title: 'Excessive Time Pressure / Multiple Tasks',
					...OBSERVATIONS_INITIAL_VALUES
				},
				distraction_inattention_interruption: {
					title: 'Distraction / Inattention / Interruption',
					...OBSERVATIONS_INITIAL_VALUES
				},
				horseplay_negative_peer_interactions: {
					title: 'Horseplay / Negative Peer Interactions',
					...OBSERVATIONS_INITIAL_VALUES
				},
				heat_cold_weather_stress: {
					title: 'Heat / Cold / Weather Stress',
					...OBSERVATIONS_INITIAL_VALUES
				},
				crew_stops_asks_when_unsure: {
					title: 'Crew Stops/Asks When Unsure',
					...OBSERVATIONS_INITIAL_VALUES
				},
				supervisor_communication_guidance: {
					title: 'Supervisor Communication / Guidance',
					...OBSERVATIONS_INITIAL_VALUES
				}
			}
		}
	},
	unsafe_acts_procedure_deviations: {
		fields: {
			improper_tool_use: {
				title: 'Improper Tool Use',
				...RADIOS_INITIAL_VALUES
			},
			improper_tie_off: {
				title: 'Improper Tie-off',
				...RADIOS_INITIAL_VALUES
			},
			walking_under_load: {
				title: 'Walking Under Load',
				...RADIOS_INITIAL_VALUES
			},
			crossing_barricade: {
				title: 'Crossing Barricade',
				...RADIOS_INITIAL_VALUES
			},
			climbing_structure: {
				title: 'Climbing Structure',
				...RADIOS_INITIAL_VALUES
			},
			permit_violation: {
				title: 'Permit Violation',
				...RADIOS_INITIAL_VALUES
			},
			bypassing_safety_device: {
				title: 'Bypassing Safety Device',
				...RADIOS_INITIAL_VALUES
			},
			endangering_others: {
				title: 'Endangering Others',
				...RADIOS_INITIAL_VALUES
			},
			reckless_driving: {
				title: 'Reckless Driving',
				...RADIOS_INITIAL_VALUES
			},
			client_rule_violation: {
				title: 'Client Rule Violation',
				...RADIOS_INITIAL_VALUES
			},
			working_impaired: {
				title: 'Working Impaired',
				...RADIOS_INITIAL_VALUES
			},
			exceeds_skills_training: {
				title: 'Exceeds Skills/Training',
				...RADIOS_INITIAL_VALUES
			}
		},
		additional_act_procedure: []
	},
	comments: '',
	violations: [VIOLATION_INITIAL_VALUES]
};
